import React, { useEffect } from "react";
import { Box, Typography, Button, Stack } from "@mui/joy";
import PodiumImg from "../podium-vector.png";
import "./Bills/Bills.css";

function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | Civic Engage";
  }, []);

  const goToBills = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/bills");
  };

  const goToLegislators = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/legislators");
  };

  return (
    <Stack
      className="loading-container"
      direction={"column"}
      padding={2}
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={PodiumImg} alt={"podium decorative"} width="300" height="300" />
      <Box className="loading-title">
        <Typography level="h1" color="primary" sx={{ textAlign: "center" }}>
          Oops! This Page Didn’t Pass the Vote
        </Typography>
        <Typography
          className="not-found"
          level="title-md"
          sx={{ marginTop: 2, textAlign: "center" }}
        >
          Looks like this page didn’t make it through committee. But no
          filibusters here—let’s get you back on track. Let’s find your way back
          to the issues that matter most.
        </Typography>
      </Box>
      <Box className="not-found-buttons">
        <Button variant="outlined" onClick={() => goToBills()}>
          Explore Legislation
        </Button>
        <Button onClick={() => goToLegislators()}>
          Find Your Representative
        </Button>
      </Box>
    </Stack>
  );
}

export default NotFound;
